// app管理API
import request from '@/utils/request'
/**
 *app记录分页
 * @param data
 * @returns {*}
 */
export function appPage(params,data) {
    return request({
        url: '/app/version/page',
        method: 'post',
        data,
        params
    })
}
/**
 * 添加app记录
 * @param data
 * @returns {*}
 */
export function appAdd(data) {
    return request({
        url: '/app/version',
        method: 'post',
        data
    })
}
/**
 * 编辑app记录
 * @param data
 * @returns {*}
 */
export function appEdit(data) {
    return request({
        url: '/app/version',
        method: 'put',
        data
    })
}
